/**
 * Derives the active tenant slug from the current browser hostname.
 * Mirrors the detection logic in backend-homeiq/src/middleware/tenant.middleware.ts.
 *
 * Detection order:
 *  1. REACT_APP_TENANT_SLUG env var (highest priority — useful for dev/test)
 *  2. Subdomain of the current hostname (e.g. brandsmart.homeiq.com → 'brandsmart')
 *  3. Fall back to 'brandsmart' (default tenant)
 */
export function detectTenantSlugFromHostname(): string {
  // Env var override (set in .env for local dev against a specific tenant)
  const envSlug = process.env.REACT_APP_TENANT_SLUG;
  if (envSlug) return envSlug.toLowerCase();

  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Subdomain pattern: e.g. brandsmart.homeiq.com (3+ parts, first is not 'www'/'api', not an IP)
  if (
    parts.length >= 3 &&
    parts[0] !== 'www' &&
    parts[0] !== 'api' &&
    !/^\d/.test(parts[0])
  ) {
    return parts[0].toLowerCase();
  }

  return 'brandsmart';
}
